import { getValueByUrlKey } from '../utils/get-value-by-url-key';
const logoMap = {
    'meet.ecid': 'images/logo-ecid.svg',
    'meet.medvar': 'images/logo-medvar.svg',
    'meet.mentor': 'images/logo-mentor.svg',
    operative: 'images/logo-operative.svg',
};
export const getLogo = () => {
    const logo = getValueByUrlKey(['meet.ecid', 'meet.medvar', 'meet.mentor', 'operative'], logoMap) ?? logoMap.operative;
    return logo;
};
